import { render, staticRenderFns } from "./BimviewerDev.vue?vue&type=template&id=1403b536&"
import script from "./BimviewerDev.vue?vue&type=script&lang=js&"
export * from "./BimviewerDev.vue?vue&type=script&lang=js&"
import style0 from "./BimviewerDev.vue?vue&type=style&index=0&id=1403b536&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports